import { createSlice } from "@reduxjs/toolkit";
import {IUser} from "./UserSlice";
import {StreamFormat, StreamQuality} from "./StreamSlice";

export interface IProfileSettings {
	stream_format_priority: StreamFormat,
	stream_quality_priority: StreamQuality,
}

export interface IProfileStatistics {
	start_date: string,
	end_date: string,
	taken: number,
}

export interface ProfileState {
	profile: IUser|null,
	settings: IProfileSettings|null,
	statistics: IProfileStatistics[],

	gettingItem:  boolean,
	gettingItemSettings: boolean,
	gettingStatistics: boolean,
	updatingItemSettings: boolean,

	isError: boolean,
	errorCode: number,
	errorMessage: null|string,
}

export const initialState: ProfileState = {
	profile: null,
	settings: null,
	statistics: [],

	gettingItem:  false,
	gettingItemSettings: false,
	gettingStatistics: false,
	updatingItemSettings: false,

	isError:      false,
	errorCode:    0,
	errorMessage: null,
};

export const ProfileSlice = createSlice({
	name: 'profile',
	initialState,
	reducers: {

		onLoadItem: (state, action ): ProfileState => {
			return { ...state, gettingItem: true };
		},
		onLoadItemSettings: (state, action ): ProfileState => {
			return { ...state, gettingItemSettings: true };
		},
		onLoadItemStatistics: (state, action ): ProfileState => {
			return { ...state, statistics: [], gettingStatistics: true };
		},
		onLoadUpdateSettings: (state, action ): ProfileState => {
			return { ...state, updatingItemSettings: true };
		},


		onSuccessItem: (state, action): ProfileState => {
			return { ...state, profile: action.payload.data, gettingItem: false };
		},
		onSuccessItemSettings: (state, action): ProfileState => {
			return { ...state, settings: action.payload.data, gettingItemSettings: false };
		},
		onSuccessItemStatistics: (state, action): ProfileState => {
			return { ...state, statistics: action.payload.data, gettingStatistics: false };
		},
		onSuccessUpdateSettings: (state, action): ProfileState => {
			return { ...state, settings: action.payload.data, updatingItemSettings: false };
		},


		onFailItem: (state, action): ProfileState => {
			return { ...state, gettingItem: false };
		},
		onFailItemSettings: (state, action): ProfileState => {
			return { ...state, settings: null, gettingItemSettings: false };
		},
		onFailItemStatistics: (state, action): ProfileState => {
			return { ...state, statistics: [], gettingStatistics: false };
		},
		onFailUpdateSettings: (state, action): ProfileState => {
			return { ...state, settings: null, updatingItemSettings: false };
		},
	},
});

